import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable } from 'rxjs';
import { switchMap, tap, catchError } from 'rxjs/operators';
import { IGetInstallationDetailResponse } from '../../installations/models/installation';
import { InstallationService } from '../../installations/services/installation.service';

export interface InstallationState {
  installation: IGetInstallationDetailResponse | null;
}

@Injectable()
export class InstallationStore extends ComponentStore<InstallationState> {

  // Initial state
  constructor(private installationService: InstallationService) {
    super({ installation: null });
  }

  // Selector for the current installation
  readonly selectedInstallation$: Observable<IGetInstallationDetailResponse | null> = this.select(state => state.installation);

  // Effect to load installation by ID from the server
  readonly getInstallationById = this.effect<string>(installationId$ =>
    installationId$.pipe(
      switchMap(installationId =>
        this.installationService.getInstallationById(installationId).pipe(
          tap({
            next: (installation) => this.patchState({ installation }),
            error: (err) => console.error('Failed to load installation:', err)
          }),
          catchError((err) => {
            console.error('Failed to load installation:', err);
            return [];
          })
        )
      )
    )
  );
}
